export function removeEmptyAttributes(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => !isValueEmpty(value))
  )
}

function isValueEmpty(value) {
  return (
    value === null ||
    (Array.isArray(value) && value.length === 0) ||
    (Array.isArray(value) && value.length === 1 && value[0] === null)
  )
}
